import { render, staticRenderFns } from "./MovieSearch.vue?vue&type=template&id=5657b71d&scoped=true"
import script from "./MovieSearch.vue?vue&type=script&lang=js"
export * from "./MovieSearch.vue?vue&type=script&lang=js"
import style0 from "./MovieSearch.vue?vue&type=style&index=0&id=5657b71d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5657b71d",
  null
  
)

export default component.exports